var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.canPlace ? _c('div', {
    staticClass: "absolute pointer-events-none opacity-80",
    style: {
      left: _vm.col * _vm.cellSize + 'px',
      top: _vm.row * _vm.cellSize + 'px',
      width: _vm.pieceWidth + 'px',
      height: _vm.pieceHeight + 'px'
    }
  }, [_c('div', {
    staticClass: "grid gap-[2px] h-full w-full",
    style: {
      gridTemplateColumns: `repeat(${_vm.activeBlock.block.shape[0].length}, 1fr)`,
      gridTemplateRows: `repeat(${_vm.activeBlock.block.shape.length}, 1fr)`
    }
  }, _vm._l(_vm.flatShape, function (item) {
    return _c('div', {
      key: `${item.r}-${item.c}`,
      class: `rounded-[2px] ${item.cell ? _vm.LIGHT_COLOR_MAP[_vm.activeBlock.block.color] : 'bg-transparent'}`
    });
  }), 0)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };